<template>
  <div style="padding:1rem;padding-left:1.2rem;position:relative;page-break-after:always;page-break-before:always;background-color:#fff;">
    <div v-if="reportInfo.language==='English'" >
    <div style="height:20px;height:50pt;">
      <div style="float:left;font-family:Times New Roman;padding-left:1rem;padding-top:0.6rem;"><img :src="logoUrl" style="width:1.8rem;"/></div>
      <div style="position:absolute;top:1.5rem;right:10rem;" v-if="coverInfo.stamp&&coverInfo.stamp.cma"><img :src="cmaStamp" style="height:1.3rem;"/></div>
      <div style="position:absolute;top:1.5rem;right:6.5rem;" v-if="coverInfo.stamp&&coverInfo.stamp.cnas"><img :src="cnasStamp" style="height:1.3rem;"/></div>
      <div style="float:right;over-flow:hidden;font-weight:600;">
        <div style="float:left;margin-top:0.5rem;transform:scale(0.7,0.7);">
          <p style="font-size:0.6rem;font-family:'KaiTi';">Report No.:<span style="float:right;font-family:Times New Roman;position:relative;">{{reportInfo.report_display_no}}</span></p>
        </div>
        
      </div>
    </div>
    <div>
      <p style="font-size:1.2rem;font-weight:600;font-family:Times New Roman;margin-top:0.4rem;">TEST&nbsp;REPORT</p>
    </div>
    <div style="text-align:center;margin:0 auto;margin-top:0.5rem;margin-left:-3rem;font-weight:600;">
    <table style="transform:scale(0.6,0.6);font-size:0.5rem;width:116%;">
      <tr>
        <td style="text-align:left;width:6.5rem;">
        <p style="font-family:Times New Roman;">Name of Item</p></td>
        <td style="border-bottom:1px solid #000;width:22rem;font-family:KaiTi;">
          <div style="min-height:1.6rem;display:flex;justify-content:center;align-items:center;">{{coverInfo.sampleName}}</div></td>
      </tr>
      <tr>
        <td style="text-align:left;padding-top:0.8rem;">
        <p style="font-family:Times New Roman;">Type/Spec</p></td>
        <td style="border-bottom:1px solid #000;font-family:KaiTi;">
          <div style="min-height:1.6rem;display:flex;justify-content:center;align-items:center;">{{coverInfo.spec}}</div></td>
      </tr>
      <tr>
        <td style="text-align:left;padding-top:0.8rem;">
        <p stely="font-family:Times New Roman;">Client</p></td>
        <td style="border-bottom:1px solid #000;font-family:KaiTi;">
          <!--<div :style="fontCssClient">
            <p v-for="ele in clientSplit" :key="ele" >
            {{ele}}</p>
            </div>-->
            <div style="min-height:1.6rem;padding-top:0.2rem;">
              {{coverInfo.client.replace('+','')}}
            </div>

            </td>
      </tr>
      <tr>
        <td style="text-align:left;padding-top:0.8rem;">
        <p stely="font-family:Times New Roman;">Client Address</p></td>
        <td style="border-bottom:1px solid #000;font-family:KaiTi;">
          <!--<div :style="fontCssAddress">
            <p v-for="ele in clientAddressSplit" :key="ele" >
            {{ele}}</p>
            </div>-->
              <div style="min-height:1.6rem;padding-top:0.2rem;">
              {{coverInfo.clientAddress.replace('+','')}}
            </div>
            </td>
      </tr>
      <tr>
        <td style="text-align:left;padding-top:0.8rem;">
        <p stely="font-family:Times New Roman;">Category of Test</p></td>
        <td style="border-bottom:1px solid #000;font-family:KaiTi;">
          <div style="min-height:1.6rem;display:flex;justify-content:center;align-items:center;">Commission</div></td>
      </tr>
    </table>
    </div>
    <div style="text-align:center;width:130%;transform:scale(0.6,0.6);margin-left:-15%;margin-top:0.3rem;padding-bottom:2rem;"> 
      <p style="font-size:0.7rem;font-family:Times New Roman;font-weight:600;">Shanghai Railway Certification Co., Ltd.</p>
    </div>
    <div style=""><p style="font-size:0.5rem;font-family:KaiTi;font-weight:400;color:#666;transform:scale(0.6,0.6);margin-top:-0.5rem;margin-bottom:1.0rem;">Test&nbsp;Stamp</p></div>
    <div style="position:absolute;bottom:1.6rem;right:6.5rem;"><img :src="testStamp" style="height:3.5rem;"/></div>
    <!--<div style="position:absolute;right:0.2rem;top:48%;writing-mode:vertical-lr;font-family:KaiTi;font-weight:400;color:#666;transform:scale(0.6,0.6);font-size:0.5rem;">骑缝章</div>-->
  </div>
  <div v-else>
    <div style="height:20px;height:50pt;">
      <div style="float:left;font-family:Times New Roman;padding-left:1rem;padding-top:0.6rem;"><img :src="logoUrl" style="width:1.8rem;"/></div>
      <div style="position:absolute;top:1.5rem;right:10rem;" v-if="coverInfo.stamp&&coverInfo.stamp.cma"><img :src="cmaStamp" style="height:1.3rem;"/></div>
      <div style="position:absolute;top:1.5rem;right:6.5rem;" v-if="coverInfo.stamp&&coverInfo.stamp.cnas"><img :src="cnasStamp" style="height:1.3rem;"/></div>
      <div style="float:right;over-flow:hidden;font-weight:600;margin-right:-0.4rem;">
        <div style="float:left;margin-top:0.5rem;transform:scale(0.7,0.7);">
          <p style="font-size:0.5rem;font-family:'KaiTi';">报告编号：<span style="float:right;font-size:0.6rem;font-family:Times New Roman;position:relative;top:0.1rem;">{{reportInfo.report_display_no}}</span></p>
          <p style="font-size:0.4rem;font-family:Times New Roman;">Report No.</p>
        </div>
        
      </div>
    </div>
    <div>
      <p
        style="font-size:1.4rem;font-family:KaiTi;font-weight:600;margin-top:0.7rem;color:#000;"
      >检&nbsp;&nbsp;测&nbsp;&nbsp;报&nbsp;&nbsp;告</p>
      <p style="font-size:0.6rem;font-weight:600;font-family:Times New Roman;margin-top:0.3rem;">TEST &nbsp;&nbsp;REPORT</p>
    </div>
    <div style="text-align:center;margin:0 auto;margin-top:-1rem;margin-left:-3rem;font-weight:600;">
    <table style="transform:scale(0.6,0.6);font-size:0.5rem;width:116%;">
      <tr>
        <td style="text-align:left;width:6.5rem;"><p style="font-family:KaiTi;font-size:0.8rem;">样品名称</p>
        <p style="font-family:Times New Roman;">&nbsp;Name of Item</p></td>
        <td style="border-bottom:1px solid #000;width:22rem;font-family:KaiTi;">
          <div style="min-height:1.6rem;display:flex;justify-content:center;align-items:center;">{{coverInfo.sampleName}}</div></td>
      </tr>
      <tr>
        <td style="text-align:left;padding-top:0.8rem;"><p style="font-family:KaiTi;font-size:0.8rem;">型号/规格</p>
        <p style="font-family:Times New Roman;">&nbsp;Type/Spec</p></td>
        <td style="border-bottom:1px solid #000;font-family:KaiTi;">
          <div style="min-height:1.6rem;display:flex;justify-content:center;align-items:center;">{{coverInfo.spec}}</div></td>
      </tr>
      <tr>
        <td style="text-align:left;padding-top:0.8rem;"><p style="font-family:KaiTi;font-size:0.8rem;">委托单位</p>
        <p stely="font-family:Times New Roman;">&nbsp;Client</p></td>
        <td style="border-bottom:1px solid #000;font-family:KaiTi;">
          <!--<div :style="fontCssClient">
            <p v-for="ele in clientSplit" :key="ele" >
            {{ele}}</p>
            </div>-->
            <div style="min-height:1.6rem;padding-top:0.2rem;">
              {{coverInfo.client.replace('+','')}}
            </div>

            </td>
      </tr>
      <tr>
        <td style="text-align:left;padding-top:0.8rem;"><p style="font-family:KaiTi;font-size:0.8rem;">委托单位地址</p>
        <p stely="font-family:Times New Roman;">&nbsp;Client Address</p></td>
        <td style="border-bottom:1px solid #000;font-family:KaiTi;">
          <!--<div :style="fontCssAddress">
            <p v-for="ele in clientAddressSplit" :key="ele" >
            {{ele}}</p>
            </div>-->
              <div style="min-height:1.6rem;padding-top:0.2rem;">
              {{coverInfo.clientAddress.replace('+','')}}
            </div>
            </td>
      </tr>
      <tr>
        <td style="text-align:left;padding-top:0.8rem;"><p style="font-family:KaiTi;font-size:0.8rem;">检测类别</p>
        <p stely="font-family:Times New Roman;">&nbsp;Category of Test</p></td>
        <td style="border-bottom:1px solid #000;font-family:KaiTi;">
          <div style="min-height:1.6rem;display:flex;justify-content:center;align-items:center;">委托检测</div></td>
      </tr>
    </table>
    </div>
    <div style="text-align:center;width:130%;transform:scale(0.6,0.6);margin-left:-15%;margin-top:-15%;">
      <p style="font-size:0.8rem;font-family:KaiTi;line-height:2rem;font-weight:600;">上海轨道交通检测技术有限公司</p>
      <p style="font-size:0.7rem;font-family:Times New Roman;font-weight:600;">Shanghai Railway Certification Co., Ltd.</p>
      <p style="font-size:0.5rem;font-family:KaiTi;line-height:1.4rem" v-show="reportInfo.report_display_no[4]!=='T'&&reportInfo.report_display_no[4]!=='E'">（原上海市机械制造工艺研究所有限公司 检测中心）</p>
    </div>
    <div style=""><p style="font-size:0.5rem;font-family:KaiTi;font-weight:400;color:#666;transform:scale(0.6,0.6);margin-top:-0.5rem;margin-bottom:1.0rem;">检测专用章</p></div>
    <div style="position:absolute;bottom:1.6rem;right:6.5rem;"><img :src="testStamp" style="height:3.5rem;"/></div>
    
  </div>
  </div>
  
</template>
<script>
export default {
  name: "coverPage",
  props: {
    coverInfo: {
      type:Object,
      default(){
        return {
        sampleName: "样品",
        spec: "-",
        client: "未知",
        clientAddress: "暂无",
      };
      }
    },
    reportInfo: {
      type: Object,
      default(){
        return {
        sampleName: "样品",
        contractNo: NaN,
        report_display_no:"",
        project_display_no:'',
        sampleAmount: "1",
        testLocation: "广粤支路87号",
        receiptDate: "",
        testDate: "",
        sampleInfo: "",
        language:"中文(简体)",
        standardList: []
      };
      }
    },
    qrCodeUrl:{
      type:String,
      default:"nonValid"
    }
  },
  components: {},
  data() {
    return {
      logoUrl: process.env.BASE_URL + "img/reportCoverPageLogo.png",
      cnasStamp: process.env.BASE_URL + "img/CNAS.png",
      cmaStamp: process.env.BASE_URL + "img/CMA.png",
      testStamp: process.env.BASE_URL + "img/TEST.png",
      fontCssClient:{},
      fontCssAddress:{}
    };
  },
  computed:{
    clientSplit:function(){
      return this.coverInfo.client.split('+');
    },
    clientAddressSplit:function(){
      return this.coverInfo.clientAddress.split('+');

      },
      

  },
  mounted(){
  },
  watch:{
    coverInfo:{
      handler:function(){
        setTimeout(()=>{
          this.fontCssClient = this.fontCssFac('client');
        this.fontCssAddress = this.fontCssFac('clientAddress');

        },1000)
        
      },
      deep:true,
    }

  },
  methods: {
    fontCssFac(key){
      let tmp = this.coverInfo[key].split('+');
      
      let limitWidth = 400;
      let fs = 17;
      let ls = 0;
      let maxWidth = 0;
      let oneLine = 0;
      if(tmp.length===1){
        limitWidth = 800;
      }
      let measureDom = document.getElementById('measure');
      if(measureDom!==null){
      measureDom.append(mp);
      let mp = document.createElement('p');
      mp.style.width = 'fit-content';
      do{
        if(fs>13){
        fs--;
        }else if(ls>-1.5){
          ls = ls-0.5;
        }else{
          break;
        }
        mp.style.fontSize = fs+'pt';
        mp.style.letterSpacing = ls+'pt';
        maxWidth = Math.max(...(tmp.map(ele=>{
          mp.innerText = ele;
          return mp.offsetWidth;
        })));
      }while(maxWidth>limitWidth);
      if(fs===16&&maxWidth<400&&maxWidth!==0){
        oneLine = 1;
      }
      let result = {
        minHeight:'55pt',
        paddingTop:(19-fs)*2+'pt',
        fontSize:fs+'pt',
        lineHeight:(fs-4)*2+28*oneLine+'pt',
        letterSpacing:ls+'pt',
      };
      return result;
      }else{
        return {};
      }
    }
  },
};
</script>
<style scoped>
div,p{
  padding: 0;
  margin:0;
}

tr,td{
  padding: 0;
  margin:0;
}
</style>